'use client';

import React, { FC, useState, useId } from 'react';
import { Document } from '@contentful/rich-text-types';

import { TypeKeyValuePairFields } from '@/core/generated-types';
import { RichText } from '@/components';
import { ChevronIcon } from '@/components/ui/Icons';
import classNames from 'classnames';

const Accordion: FC<TypeKeyValuePairFields> = ({ title, value }) => {
  const [isOpen, setIsOpen] = useState(false);
  const accordionId = useId();

  return (
    <button
      id={accordionId}
      aria-expanded={isOpen}
      aria-controls={`sect-${accordionId}`}
      className={classNames(
        'accordion collapse mx-auto border-t border-y-charcoal-opacity-20 md:container last:border-b w-full',
        isOpen ? 'collapse-open' : 'collapse-close',
      )}
      onClick={() => setIsOpen(!isOpen)}
      data-testid="accordion-collapse-button"
    >
      <div className="collapse-title cursor-pointer py-6 text-base font-bold md:py-6 md:text-base md:text-lg relative">
        <p className="accordion-title text-left pr-12">{title} </p>
        <ChevronIcon
          classes="mt-1 min-w-[16px] absolute top-1/2 transform -translate-y-1/2 right-4"
          direction={isOpen ? 'up' : 'down'}
        />
      </div>
      <div
        role="region"
        id={`sect-${accordionId}`}
        aria-labelledby={accordionId}
        className="collapse-content"
      >
        <div className="pb-6 text-base text-left">
          {value && <RichText content={value as Document} />}
        </div>
      </div>
    </button>
  );
};

export default React.memo(Accordion);
